export default "__VITE_ASSET__CX257yC8__"